import React from "react"
import { FiChevronRight } from "react-icons/fi"

import * as style from "./Postman.module.scss"

const Postman = ({ id, onClick, url }) => (
  <div className={style.postman} onClick={onClick}>
    <FiChevronRight />
    <p>Run in Postman</p>
    <div
      className="postman-run-button"
      data-postman-action="collection/fork"
      data-postman-var-1={id}
      data-postman-collection-url={url}
    />
  </div>
)

export default Postman
